import { DynamicState, GenericState } from '../models';

export class SelectorUtil {
    static isLoading({ status }: GenericState<any> | DynamicState<string, any>) {
        return status === 'loading';
    }

    static isDone({ status }: GenericState<any> | DynamicState<string, any>) {
        return status === 'success' || status === 'error';
    }
}
